// Bridge's KYC link points at Persona's hosted /verify page, which can't be framed
// (X-Frame-Options). Per Bridge support, the embeddable equivalent swaps /verify for
// /widget and passes the embedding origin as iframe-origin.
export const toWidgetUrl = (url: string, origin: string): string => {
  try {
    const widgetUrl = new URL(url);
    // Leave non-https URLs (e.g. Storybook's mock data: URL) untouched.
    if (widgetUrl.protocol !== 'https:') return url;

    widgetUrl.pathname = widgetUrl.pathname.replace(/\/verify$/, '/widget');
    widgetUrl.searchParams.set('iframe-origin', origin);
    return widgetUrl.toString();
  } catch {
    return url;
  }
};
